import { ZUid } from "src/types/zUid";
import { EdObject } from "../EdObject";
import { ZNotifyType } from "../NotifyTemplates/ZNotifyTemplate";
import { EdDelayedNotify } from "./EdDelayedNotify";

export const root: keyof EdObject = "delayedNotifyMap";

export const fKey = (key: keyof EdDelayedNotify) => key;

const typesMap: Record<ZNotifyType, string> = {
  [ZNotifyType.push]: "Push",
  [ZNotifyType.email]: "Email",
  [ZNotifyType.all]: "Все",
};
export const typeOptions = (): { value: number; label: string }[] =>
  Object.entries(typesMap).map(([key, label]) => ({ value: +key, label }));

export const defaulDelayedNotify: EdDelayedNotify = {
  active: true,
  roleIds: [],
  receiverAttrIds: [],
  departmentAttrId: undefined as unknown as ZUid,
  messageType: undefined as unknown as number,
  templateText: {},
  days: undefined as unknown as number,
};
